import { FeatureFlags } from '../../../feature-flags/feature-flags';
import Global from '../../global-selectors';

export const getSellerDefaultData = (state) => {
  return {
    defaultDimensionUnit: Global.selectSellerDefaultDimensionUnit(state),
    defaultCustomsData: Global.selectSellerDefaultCustomData(state),
    defaultCurrency: Global.selectSellerDefaultCurrency(state),
    defaultWeightUnit: Global.selectSellerDefaultWeightUnit(state),
  };
};

export const getFeatureFlagsThatAffectShippingConfig = (state) => {
  const { enableLocalDeliveryDriverTip } = new FeatureFlags({ state });
  return {
    enableLocalDeliveryDriverTip,
  };
};

export const getSalesOrderStoreTemplateData = (state, fulfillmentPlanId) => {
  const salesOrderId = (Global.selectEntitiesFulfillmentPlanProperty(state, {
    fulfillmentPlanId,
    property: 'salesOrdersFulfilledIds',
  }) || [])[0];
  if (!salesOrderId) {
    return {};
  }
  const orderStoreId = Global.selectEntitiesSalesOrderProperty(state, {
    salesOrderId,
    property: 'store.storeGuid',
  });
  return {
    storeShipmentEmailNotificationTemplateId: Global.selectSellerShipmentTemplateIdByStoreId(state, {
      storeGuid: orderStoreId,
    }),
    storeDeliveryEmailNotificationTemplateId: Global.selectSellerDeliveryTemplateIdByStoreId(state, {
      storeGuid: orderStoreId,
    }),
    packingSlipTemplateId: Global.selectSellerPackingSlipIdByStoreId(state, {
      storeGuid: orderStoreId,
    }),
  };
};
